import { useState, useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import CheckIcon from "@mui/icons-material/Check";

export function ShareButton({ restaurantId, dealId, size }) {
 const [copied, setCopied] = useState(false);

 useEffect(() => {
  if (copied) {
   const timeout = setTimeout(() => setCopied(false), 2000);
   return () => clearTimeout(timeout);
  }
 }, [copied]);

 const handleShare = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const isDeal = !!dealId;
  const shareUrl = isDeal
   ? `${window.location.origin}/restaurant/${restaurantId}/deal/${dealId}`
   : `${window.location.origin}/restaurant/${restaurantId}`;

  const title = isDeal ? "Check out this deal!" : "Check out this restaurant!";

  if (navigator.share) {
   try {
    await navigator.share({ title, url: shareUrl });
   } catch (error) {
    console.error("Error sharing", error);
   }
  } else {
   await navigator.clipboard.writeText(shareUrl);
   setCopied(true);
  }
 };

 return (
  <Tooltip title={copied ? "Link copied!" : "Share"} arrow>
   <IconButton
    onClick={handleShare}
    color="text.disabled"
    {...(size && { size })}
   >
    {copied ? <CheckIcon /> : <ShareIcon />}
   </IconButton>
  </Tooltip>
 );
}
